'use strict';

import EventDispatcher from './integration/eventDispatcher';
import './integration/voyado';

export default EventDispatcher;
